const x = {
  xs: "18px",
  sm: "24px",
  md: "32px",
  lg: "38px",
  xl: "46px"
};
export {
  x as SPINNER_SIZES
};
